import React from 'react'
import { UnoUtil } from 'uno-security-common'

const EaseContactInfo = UnoUtil.EaseContactInfo;

class ForgetUserNameConfirmComponent extends React.Component {
    constructor(props){
        super(props);
        this.cmeUno = props.cmeUno;
    }

    render(){
        const messages = this.cmeUno.messages;
        return (
            <div>
                <p><strong>{messages['ForgetUserName.subheader.emailSent']}</strong></p>
                <p>{messages['ForgetUserName.confirm.message1']}</p>
                <p>{messages['ForgetUserName.confirm.message2']}</p>

                <EaseContactInfo messages={messages}/>
            </div>
        );
    }
}

export default ForgetUserNameConfirmComponent;
